import React from "react";
import { Task, TaskDefinition } from "../../models";

export interface Question extends QuestionDefinition {
  options?: { key: string, displayName: string, followUpQuestions?: QuestionDefinition[], mutuallyExclusive?: boolean }[];
  additionialQuestion?: Question;
  group?: string;
}

export interface QuestionGroup {
  key: string;
  title?: string;
  description?: string;
  content?: React.ReactNode;
  questions: Question[];
  condition?: (questionnaire: Questionnaire) => boolean;
}

export interface Questionnaire extends Task {
  groups: QuestionGroup[];
  key: string;
}

export interface QuestionnaireDefinition extends TaskDefinition {
  groups: QuestionDefinitionGroup[];
  key: string;
}

export interface QuestionDefinitionGroup {
  key: string;
  title?: string;
  description?: string;
  content?: React.ReactNode;
  questions: QuestionDefinition[];
  condition?: (questionnaire: Questionnaire) => boolean;
}

export interface QuestionDefinition {
  key: string;
  type: string;
  question: string;
  content?: React.ReactNode;
  hint?: string;
  options?: { key: string, displayName: string, followUpQuestions?: QuestionDefinition[], mutuallyExclusive?: boolean }[];
  condition?: (questionnaire: Questionnaire) => boolean;
  validation?: (questionnaire: Questionnaire) => boolean;
  value: null | string | string[] | Date;
  defaultValue: null | string | string[] | Date;
  unit?: string;
  required?: boolean;
  additionialQuestion?: QuestionDefinition;
  invalidText?: string;
  placeholder?: string;
  requiredMessage?: string;
  className?: string;
}

export const METRIC_UNITS = '1';
export const US_CUSTOMARY_UNITS = '2';
